// extracted by mini-css-extract-plugin
export default {"container":"Suggestions_container__mmnLz","suggestionWrapper":"Suggestions_suggestionWrapper__Z-W0O","suggestion":"Suggestions_suggestion__E30sX"};